// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var ballotStylesSlice = createSlice({
    name: "ballotStyles",
    initialState: initialState,
    reducers: {
        setBallotStyle: function (state, action) {
            state[action.payload.election_id] = action.payload;
            return state;
        },
    },
});
export var setBallotStyle = ballotStylesSlice.actions.setBallotStyle;
export var selectBallotStyleByElectionId = function (electionId) { return function (state) {
    return state.ballotStyles[electionId];
}; };
export var selectBallotStyleElectionIds = function (state) { return Object.keys(state.ballotStyles); };
export var selectFirstBallotStyle = function (state) { var _a; return (_a = Object.values(state.ballotStyles)) === null || _a === void 0 ? void 0 : _a[0]; };
export var selectAllBallotStyles = function (state) {
    return state.ballotStyles
        ? Object.values(state.ballotStyles)
            .filter(function (bs) { return bs; })
            .map(function (bs) { return bs; })
        : [];
};
export var showDemo = function (electionId) { return function (state) {
    var isPreview = sessionStorage.getItem("isDemo");
    if (isPreview) {
        return isPreview === "true";
    }
    var ballotStyles = selectAllBallotStyles(state);
    var filteredBallotStyles = ballotStyles.filter(function (bs) {
        return electionId ? bs.election_id === electionId : true;
    });
    return filteredBallotStyles.some(function (bs) { var _a; return (_a = bs === null || bs === void 0 ? void 0 : bs.ballot_eml.public_key) === null || _a === void 0 ? void 0 : _a.is_demo; });
}; };
export default ballotStylesSlice.reducer;
